import * as React from 'react';

import {Prefix} from './tooltip-prefixes';
import {formatNumber} from './tooltip-utils';

import styles from './tooltips.module.css';

type TooltipTotalsRowProps = {
    count: number | null | undefined;
    total: number | null | undefined;
    currencyPrefix: string;
};
export function TooltipTotalsRow({count, total, currencyPrefix}: TooltipTotalsRowProps) {
    // The `total` facet  is only set for leads reports.
    if (total !== null && total !== undefined) {
        return (
            <tr key='total' className={styles['row--total']}>
                <td className={styles['data-value']}>{formatNumber(count)} leads</td>
                <Prefix currencyPrefix={currencyPrefix} />
                <td className={styles['data-value']}>{formatNumber(total)}</td>
            </tr>
        );
    }

    // For other types like  the activity report, we can just show the count without needing a label.
    return (
        <tr key='total' className={styles['row--total']}>
            <td className={styles['data-value']}>{formatNumber(count)}</td>
        </tr>
    );
}
